import { Link } from "react-router-dom";
import { Instagram, Linkedin, Facebook } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-kaija-sage py-12">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <Link to="/" className="block mb-4">
              <span className="text-xl font-bold text-gray-800">Kaija Alliksaar Coaching</span>
            </Link>
            <p className="text-sm text-gray-700 mb-4">
              Toetan naisi elu väljakutsetes ja nende muutmisel isiklikuks kasvuks.
            </p>
          </div>
          
          <div className="md:col-span-1">
            <h4 className="font-medium text-lg mb-4">Kiirlingid</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-gray-700 hover:text-kaija-accent">Avaleht</Link></li>
              <li><Link to="/about" className="text-sm text-gray-700 hover:text-kaija-accent">Minust</Link></li>
              <li><Link to="/courses" className="text-sm text-gray-700 hover:text-kaija-accent">Kursused</Link></li>
              <li><Link to="/contact" className="text-sm text-gray-700 hover:text-kaija-accent">Kontakt</Link></li>
            </ul>
          </div>
          
          <div className="md:col-span-1">
            <h4 className="font-medium text-lg mb-4">Teenused</h4>
            <ul className="space-y-2">
              <li><Link to="/coaching" className="text-sm text-gray-700 hover:text-kaija-accent">Coaching</Link></li>
              <li><Link to="/somatic-coaching" className="text-sm text-gray-700 hover:text-kaija-accent">Somaatiline Coaching</Link></li>
              <li><Link to="/hypnotherapy" className="text-sm text-gray-700 hover:text-kaija-accent">Hüpnoteraapia</Link></li>
              <li><Link to="/trainings" className="text-sm text-gray-700 hover:text-kaija-accent">Koolitused</Link></li>
            </ul>
          </div>
          
          <div className="md:col-span-1">
            <h4 className="font-medium text-lg mb-4">Kontakt</h4>
            <p className="text-sm text-gray-700 mb-2">Elevoria OÜ</p>
            <p className="text-sm text-gray-700 mb-2">Registrikood: 17129519</p>
            <p className="text-sm text-gray-700 mb-2">Aadress: Tiskre küla, Harku vald, Harjumaa</p>
            <p className="text-sm text-gray-700 mb-4">E-post: kaija@kaijaalliksaar.ee</p>
            
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/kaijaalliksaarcoaching/" 
                target="_blank" 
                rel="noreferrer" 
                className="text-kaija-accent hover:text-opacity-80"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://www.linkedin.com/in/kaija-alliksaar-a9019557/" 
                target="_blank" 
                rel="noreferrer" 
                className="text-kaija-accent hover:text-opacity-80"
              >
                <Linkedin size={20} />
              </a>
              <a 
                href="https://www.facebook.com/kaija.alliksaar" 
                target="_blank" 
                rel="noreferrer" 
                className="text-kaija-accent hover:text-opacity-80"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-12 pt-6 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center">
          <p className="text-xs text-gray-700 mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} Kaija Alliksaar Coaching. Kõik õigused kaitstud.
          </p>
          
          <div className="flex space-x-6">
            <Link to="/privacy" className="text-xs text-gray-700 hover:text-kaija-accent">
              Privaatsuspoliitika
            </Link>
            <Link to="/terms" className="text-xs text-gray-700 hover:text-kaija-accent">
              Müügitingimused
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
